const DEFAULT_DATA = {
  conditionProperties: [
    {
      data: {
        resource: 'activitytype',
        includeIds: null,
      },
    },
    {
      data: {
        resource: 'workflowaction',
        includeIds: null,
      },
    },
    {
      data: {
        resource: 'product',
        includeIds: null,
      }
    },
  ],
  value: undefined,
  label: undefined,
};

export default DEFAULT_DATA
